<template>
  <div :style="{
      transform: `translate3d(0, ${offset}px, 0)`,
    }" class="parallaxElement">
    <slot />
  </div>
</template>

<script>
export default {
  name: "parallaxElement",
  inject: ["parallaxContainer"],
  props: {
    factor: {
      default: 0.25,
      type: Number
    }
  },
  computed: {
    offset() {
      const { height, scrollFactor } = this.parallaxContainer;
      // The offset is relative to the height of
      // the element. This means, if the factor is
      // 0.5, the element is moved half its height
      // over the full scroll distance of the viewport.
      return scrollFactor * height * this.factor;
    }
  }
};
</script>
<style lang="scss" scoped>
.parallaxElement {
  width: 100%;
  height: 100%;
  transition: transform 0.2s linear;
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      transition: none;
    }
  }
}
</style>